import { Widget, WidgetHeight } from "@arelia-types/widget";
import AgeContainer from "./age/AgeContainer";
import AllEarningsContainer from "./all-earnings/AllEarningsContainer";
import EarningsPerMonthContainer from "./earnings-per-period/EarningsPerMonthContainer";
import EarningsPerYearContainer from "./earnings-per-period/EarningsPerYearContainer";
import FollowersContainer from "./followers/FollowersContainer";
import GenderContainer from "./gender/GenderContainer";
import InteractionsContainer from "./interactions/InteractionsContainer";
import ListenersContainer from "./streaming-charts/ListenersContainer";
import NetworksContainer from "./networks/NetworksContainer";
import PublishingRoyaltiesContainer from "./royalties/PublishingRoyaltiesContainer";
import RecordingRoyaltiesWidgetContainer from "./royalties/RecordingRoyaltiesContainer";
import SongsContainer from "./songs/SongsContainer";
import StreamsContainer from "./streaming-charts/StreamsContainer";
import TipsContainer from "./tips/TipsContainer";
import SocialCountriesContainer from "./countries/SocialCountriesContainer";
import StreamingCountriesContainer from "./countries/StreamingCountriesContainer";
import { RevenueContainer } from "./revenue/performance/PerformanceContainer";
import { MerchandiseContainer } from "./revenue/merchandise/MerchandiseContainer";
import FansDashboardContainer from "src/widgets/fans-dashboard/FansDashboardContainer";
import FansUrlContainer from "./fans-url/FansUrlContainer";
import { CampaignSmsContainer } from "./campaign-sms/CampaignSmsContainer";
import FansCampaignPerformanceContainer from "./fans-campaign-performance/FansCampaignPerformanceContainer";

export const widgets: Widget[] = [
  /* Dashboard */
  // standard widgets are displayed if no favorites are chosen

  /* Earnings */
  {
    name: "all earnings",
    id: "ALL_EARNINGS",
    component: AllEarningsContainer,
    size: 9,
    height: WidgetHeight.M,
    page: "/earnings",
  },
  {
    name: "this month",
    id: "THIS_MONTH_EARNINGS",
    component: EarningsPerMonthContainer,
    size: 3,
    height: WidgetHeight.S,
    page: "/earnings"
  },
  {
    name: "this year",
    id: "THIS_YEAR_EARNINGS",
    component: EarningsPerYearContainer,
    size: 3,
    height: WidgetHeight.S,
    page: "/earnings"
  },
  {
    name: "streaming royalties",
    id: "RECORDING_ROYALTIES",
    component: RecordingRoyaltiesWidgetContainer,
    size: 4,
    height: WidgetHeight.SM,
    page: "/earnings",
    detailsPagePath: "/earnings/streaming-royalties"
  },
  {
    name: "publishing royalties",
    id: "PUBLISHING_ROYALTIES",
    component: PublishingRoyaltiesContainer,
    size: 4,
    height: WidgetHeight.SM,
    page: "/earnings",
    detailsPagePath: "/earnings/publishing-royalties"
  },
  {
    name: "donations & tips",
    id: "TIPS",
    component: TipsContainer,
    size: 4,
    height: WidgetHeight.SM,
    page: "/earnings",
  },
  {
    name: "performance revenue",
    id: "PERFORMANCE_REVENUE",
    component: RevenueContainer,
    size: 6,
    height: WidgetHeight.L,
    page: "/earnings",
    detailsPagePath: "/earnings/performance-revenue"
  },
  {
    name: "merchandise revenue",
    id: "MERCHANDISE_REVENUE",
    component: MerchandiseContainer,
    size: 6,
    height: WidgetHeight.L,
    page: "/earnings"
  },

  /* Performance Revenue */
  {
    name: "all performance earnings",
    id: "ALL_EARNINGS_PERFORMANCE",
    component: AllEarningsContainer,
    size: 9,
    height: WidgetHeight.M,
    page: "/earnings",
    tab: "/performance-revenue",
    query: "type=Performance"
  },
  {
    name: "this month",
    id: "THIS_MONTH_EARNINGS_PERFORMANCE",
    component: EarningsPerMonthContainer,
    size: 3,
    height: WidgetHeight.S,
    page: "/earnings",
    tab: "/performance-revenue",
    query: "type=Performance"
  },
  {
    name: "this year",
    id: "THIS_YEAR_EARNINGS_PERFORMANCE",
    component: EarningsPerYearContainer,
    size: 3,
    height: WidgetHeight.S,
    page: "/earnings",
    tab: "/performance-revenue",
    query: "type=Performance"
  },
  {
    name: "performance revenue",
    id: "PERFORMANCE_REVENUE_PERFORMANCE",
    component: RevenueContainer,
    size: 6,
    height: WidgetHeight.L,
    page: "/earnings",
    tab: "/performance-revenue"
  },

  /* Social */
  {
    name: "social countries",
    id: "SOCIAL_COUNTRIES",
    component: SocialCountriesContainer,
    size: 8,
    height: WidgetHeight.L,
    page: "/my-social",
    tab: "/dashboard",
  },
  {
    name: "followers",
    id: "FOLLOWERS",
    component: FollowersContainer,
    size: 4,
    height: WidgetHeight.S,
    page: "/my-social",
    tab: "/dashboard",
    isStandard: true,
  },
  {
    name: "networks",
    id: "NETWORKS",
    component: NetworksContainer,
    size: 4,
    height: WidgetHeight.M,
    page: "/my-social",
    tab: "/dashboard",
    isStandard: true,
  },
  {
    name: "social interactions",
    id: "SOCIAL_INTERACTIONS",
    component: InteractionsContainer,
    size: 8,
    height: WidgetHeight.M,
    page: "/my-social",
    tab: "/dashboard",
    isStandard: true,
  },

  /*Streaming */
  {
    name: "listeners",
    id: "LISTENERS",
    component: ListenersContainer,
    size: 12,
    height: WidgetHeight.M,
    page: "/streaming",
    tab: "/audience",
  },
  {
    name: "audience gender",
    id: "AUDIENCE_GENDER",
    component: GenderContainer,
    size: 6,
    height: WidgetHeight.M,
    page: "/streaming",
    tab: "/audience",
  },
  {
    name: "audience age",
    id: "AUDIENCE_AGE",
    component: AgeContainer,
    size: 6,
    height: WidgetHeight.M,
    page: "/streaming",
    tab: "/audience",
  },
  {
    name: "streaming countries",
    id: "STREAMING_COUNTRIES",
    component: StreamingCountriesContainer,
    size: 8,
    height: WidgetHeight.L,
    page: "/streaming",
    tab: "/audience",
  },
  {
    name: "streams",
    id: "STREAMS",
    component: StreamsContainer,
    size: 8,
    height: WidgetHeight.M,
    page: "/streaming",
    tab: "/plays",
    isStandard: true,
  },
  {
    name: "top songs",
    id: "TOP_SONGS",
    component: SongsContainer,
    size: 4,
    height: WidgetHeight.M,
    page: "/streaming",
    tab: "/plays",
    isStandard: true,
  },

  /*My Fans*/
  {
    name: "fans count",
    id: "TOTAL_FANS_COUNT",
    component: FansDashboardContainer,
    size: 5,
    height: WidgetHeight.S,
    page: "/my-fans",
    tab: "/dashboard",
  },
  {
    name: "campaign sms",
    id: "CAMPAIGN_SMS",
    component: CampaignSmsContainer,
    size: 7,
    height: WidgetHeight.L,
    page: "/my-fans",
    tab: "/dashboard",
  },
  {
    name: "fans url",
    id: "FANS_URL",
    component: FansUrlContainer,
    size: 5,
    height: WidgetHeight.M,
    page: "/my-fans",
    tab: "/dashboard",
  },
  {
    name: "fans campaign performance",
    id: "FANS_CAMPAIGN_PERFORMANCE",
    component: FansCampaignPerformanceContainer,
    size: 12,
    height: WidgetHeight.M,
    page: "/my-fans",
    tab: "/dashboard",
  },
];
